import React, {useState} from 'react'
import {Container, Nav, Navbar} from 'react-bootstrap'
import Input from 'components/dashboard/input'
import './style.css'
import Category from 'components/dashboard/category'

export default function Navprops(props) {
    const [actived, setActived] = useState(false)

    const navBackground = _ => {
        if(window.scrollY >= 50) {
            setActived(true)
        } else {
            setActived(false)
        }
    }

    window.addEventListener('scroll', navBackground)
    return (
        <div className={actived ? "categori-nav-comp categori-nav-comp-active" : "categori-nav-comp"}>
            <Container>
            <h6>{props.inheading} <span>{props.inspan}</span></h6>
            <Navbar>
            <div className="serch-category-berberkah">
                <Input cGroup="pencarian" placeholder="Cari barang ..." />
                <Category cCategroy="category" />
            </div>
            <Nav className="me-auto">
                        {
                            Icons.map((icon, i) => {
                                return (
                                    <Nav.Link key={i}>
                                        <div className="icons">
                                            <img className={icon.cImg} src={icon.src} alt="icon" />
                                        </div>
                                    </Nav.Link>
                                )
                            })
                        } 
                    </Nav>
                </Navbar>
             </Container>
            </div>
    )
}

const Icons = [
    {src:"asset/toko_reseller/card.svg", cImg:"cart"},
    {src:"asset/toko_reseller/user.svg", cImg:"user"}
]
